const MENSAJE_GENERICO = "No fue posible completar la operación. Intente nuevamente o contacte al administrador.";

// El backend manda el mensaje de error con casing distinto según el status: "Mensaje" (500),
// "message" (401) o "errors.detalle[]" (400). Esta función normaliza los 3 casos para mostrar
// siempre un mensaje amigable con Swal, nunca el error técnico crudo.
export const extraerMensajeError = (error) => {
  if (!error) return MENSAJE_GENERICO;
  if (typeof error.Mensaje === "string" && error.Mensaje.trim()) return error.Mensaje;
  if (typeof error.message === "string" && error.message.trim()) return error.message;
  const detalle = error.errors?.detalle;
  if (Array.isArray(detalle) && detalle.length > 0) return detalle[0];
  const primerCampo = error.errors ? Object.keys(error.errors)[0] : null;
  const primerMensaje = primerCampo ? error.errors[primerCampo]?.[0] : null;
  return primerMensaje || MENSAJE_GENERICO;
};
